import React from 'react';

import VerifyEmail from 'components/verify-email';

const EmailVerification = ({ email }) => {
  return <VerifyEmail modalMode={true} email={email} />;
};

export default EmailVerification;
